export const networkAnalysisReportMessages = {
  en: {
    pageTitle: 'History of analyzing',
    tableTitle: 'Network Analysis Report',
    tableHelp:
      'Summary information and exports from the previous analysis runs.',
    actionColumnTitle: 'Action',
  },
};
